<template>
  <div :style="customStyle" class="admin-text-field-container">
    <input :type="type" :value="value" @input="debounceSearch" />
    <img :src="prependIcon" v-if="prependIcon" />
  </div>
</template>

<script>
export default {
  props: {
    debounce: {
      type: Number,
      default: 0,
    },
    value: {
      type: String | Number,
    },
    type: {
      type: String,
      default: "text",
    },
    customStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    prependIcon: {
      type: String,
    },
  },
  data() {
    return {
      deb: this.debounce,
    };
  },
  methods: {
    debounceSearch(event) {
      clearTimeout(this.deb);
      this.deb = setTimeout(() => {
        this.$emit("input", event.target.value);
      }, this.debounce);
    },
  },
};
</script>

<style  scoped>
input {
  width: 100%;
  height: 100%;
  border: none;
}

.admin-text-field-container {
  display: flex;
  align-items: center;
  border: 1px solid rgb(185, 185, 185);
  border-radius: 4px;
}
</style>
